// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-reviews-rating{display:flex;align-items:center;margin:0 -1px}@media only screen and (min-width:992px){.product-reviews-rating{margin:0 -2px}}.product-reviews-rating__icon{width:14px;height:14px;margin:0 1px;fill:var(--881fv)}.product-reviews-rating__icon.is-active{fill:var(--2bxuoz)}@media only screen and (min-width:992px){.product-reviews-rating__icon{width:24px;height:24px;margin:0 2px}}", ""]);
// Exports
module.exports = exports;
